// Utility function to load Razorpay SDK dynamically
export const loadRazorpay = () => {
  return new Promise((resolve, reject) => {
    // Check if Razorpay is already loaded
    if (window.Razorpay) {
      resolve(window.Razorpay);
      return;
    }

    // Create script element
    const script = document.createElement('script');
    script.src = 'https://checkout.razorpay.com/v1/checkout.js';
    script.async = true;
    script.onload = () => {
      if (window.Razorpay) {
        resolve(window.Razorpay);
      } else {
        reject(new Error('Razorpay failed to load'));
      }
    };
    script.onerror = () => {
      reject(new Error('Failed to load Razorpay SDK'));
    };

    // Add script to document
    document.head.appendChild(script);
  });
}; 